import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="pt-28 md:pt-36 pb-32 px-4">
      <div className="max-w-[640px] mx-auto text-center rounded-2xl border border-white/10 bg-card p-10">
        <XCircle size={52} className="mx-auto text-white/50" />
        <h1 className="font-display text-4xl md:text-5xl text-white mt-6">Checkout canceled</h1>
        <p className="mt-2 text-white/60">No worries — your bag is still saved. Pick up where you left off.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/checkout" className="bg-neon text-black font-bold uppercase tracking-widest text-sm px-8 py-4 rounded-full">Back to checkout</Link>
          <Link to="/shop" className="border border-white/30 text-white font-bold uppercase tracking-widest text-sm px-8 py-4 rounded-full hover:border-neon hover:text-neon transition">Keep shopping</Link>
        </div>
      </div>
    </main>
  );
}
